// Shared PBR-lite materials for the environment layer. Cached at module scope
// so every map + prop reuses the exact same MeshStandardMaterial instances —
// enormous perf win vs. creating fresh materials per mesh.
import * as THREE from "three";

const cache = {};

function mat(color, roughness = 0.85, metalness = 0.05, extra = {}) {
    const key = `${color}|${roughness}|${metalness}|${JSON.stringify(extra)}`;
    if (!cache[key]) {
        cache[key] = new THREE.MeshStandardMaterial({
            color,
            roughness,
            metalness,
            ...extra,
        });
    }
    return cache[key];
}

export const MAT = {
    // Concrete tones
    concrete:      () => mat("#8b8b83", 0.95, 0.05),
    concreteDark:  () => mat("#5f6560", 0.95, 0.05),
    concreteLight: () => mat("#b0aea3", 0.95, 0.05),
    // Brick — warm red
    brick:         () => mat("#7d3b2a", 0.9,  0.02),
    // Metal — painted red / dark / rusty
    metalDark:     () => mat("#3a3c40", 0.55, 0.65),
    metalRed:      () => mat("#8b2a20", 0.45, 0.55),
    metalYellow:   () => mat("#c58f2a", 0.5,  0.55),
    metalRust:     () => mat("#6b3a26", 0.85, 0.35),
    // Wood
    wood:          () => mat("#5a3b25", 0.9,  0.03),
    woodLight:     () => mat("#a67a44", 0.9,  0.03),
    // Glass — semi-transparent
    glass:         () => mat("#a4d9e6", 0.05, 0.2, { transparent: true, opacity: 0.35, envMapIntensity: 1 }),
    // Grass
    grass:         () => mat("#3c5f3a", 0.95, 0.02),
    grassDry:      () => mat("#7d7a3a", 0.95, 0.02),
    // Sand / dirt
    sand:          () => mat("#c8b075", 0.98, 0.02),
    dirt:          () => mat("#4d3a28", 0.98, 0.02),
    // Roads
    asphalt:       () => mat("#1a1a1c", 0.95, 0.05),
    asphaltMark:   () => mat("#d5d5c8", 0.9,  0.05),
    // Snow / ice
    snow:          () => mat("#e6e9ef", 0.9,  0.02),
    // Foliage
    foliage:       () => mat("#2f5230", 0.95, 0.0),
    trunk:         () => mat("#3b2a1a", 0.95, 0.0),
    // Accent lights
    lightWarm:     () => mat("#000000", 1.0,  0.0, { emissive: "#ffb26b", emissiveIntensity: 1.4 }),
    lightCool:     () => mat("#000000", 1.0,  0.0, { emissive: "#a4d9e6", emissiveIntensity: 1.2 }),
    lightRed:      () => mat("#000000", 1.0,  0.0, { emissive: "#ff5040", emissiveIntensity: 1.4 }),
    // Sign / advert
    signWhite:     () => mat("#e0dfd8", 0.85, 0.1),
    signBlue:      () => mat("#20486a", 0.85, 0.1),
    // Fabric / tent
    canvas:        () => mat("#7a6a45", 0.98, 0.02),
    // Water puddle
    puddle:        () => mat("#0f1622", 0.05, 0.3, { transparent: true, opacity: 0.65 }),
};
